var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "13",
        viewBox: "0 0 14 13",
        fill: "none"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M12 0.5C12.2651 0.500304 12.5196 0.605498 12.707 0.792969C12.8945 0.980439 12.9997 1.23488 13 1.5V11.5C12.9997 11.7651 12.8945 12.0196 12.707 12.207C12.5196 12.3945 12.2651 12.4997 12 12.5H2C1.73488 12.4997 1.48044 12.3945 1.29297 12.207C1.1055 12.0196 1.0003 11.7651 1 11.5V1.5C1.0003 1.23488 1.1055 0.980439 1.29297 0.792969C1.48044 0.605498 1.73488 0.500304 2 0.5H12ZM2 11.5H12.001L12 1.5H2V11.5ZM7 8.5C7.19891 8.5 7.38962 8.57907 7.53027 8.71973C7.67093 8.86038 7.75 9.05109 7.75 9.25C7.75 9.39834 7.70643 9.54366 7.62402 9.66699C7.54161 9.79032 7.42415 9.8866 7.28711 9.94336C7.15008 10.0001 6.99897 10.0143 6.85352 9.98535C6.70811 9.95639 6.57457 9.88511 6.46973 9.78027C6.36489 9.67543 6.29361 9.54189 6.26465 9.39648C6.23571 9.25103 6.2499 9.09991 6.30664 8.96289C6.3634 8.82585 6.45968 8.70839 6.58301 8.62598C6.70634 8.54357 6.85166 8.5 7 8.5ZM7.5 7.5H6.5V3H7.5V7.5Z",
          fill: "#333333"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-114655b6", { render: render, staticRenderFns: staticRenderFns })
  }
}